import axios from 'axios';
import * as Config from '../../config';

const state = {};

const actions = {

    defaultConfig_getUser({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
        axios.get(Config.apiPath + 'default-config/get-user/'+form.user)
                .then(
                    response => {
                        //commit('LOAD_CATEGORY', data);
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });

    },
    defaultConfig_getServices({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'default-config/get-services')
                .then(
                    response => {
                        //commit('LOAD_CATEGORY', data);
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });

    },
    defaultConfig_updateStore({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'default-config/update-store', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
};

const mutations = {};

export default {
  state,
  actions,
  mutations
};
